import Vue from 'vue/dist/vue.esm';
import { makeRestClient } from '../fn/api';

const client = makeRestClient();

export default Vue.extend({
    template: '#processNoteApp',

    data() {
        return {
            noteKey: '',
            note: '',
            loading: false,
        };
    },

    mounted() {
        this.noteKey = window.PROCESS_NOTE_KEY;

        this.get();
    },

    computed: {
        classes() {
            return ['process-note', `process-note--${this.noteKey}`];
        },
    },

    methods: {
        async get() {
            this.loading = true;

            const r = await client.get(`asys/v1/process-notes/${this.noteKey}`);

            if (r.ok) {
                this.note = (await r.json()).note;
            }

            this.loading = false;
        },

        async update() {
            this.loading = true;

            const r = await client.put(`asys/v1/process-notes/${this.noteKey}`, {
                json: {
                    note: this.note,
                },
            });

            if (!r.ok) {
                console.warn(`Failed updating process note ${this.noteKey}`);
            }

            this.loading = false;
        },

        inputChanged() {
            this.update();
        },
    },
});
